import type { WiwState } from '@/store';

export default (state: WiwState) => state.data.freeTrialStatus.loaded;
